module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "footer-container"
  }, [(_vm.$route.name === 'Index') ? _c('p', {
    staticClass: "special"
  }, [_vm._v("Специальный проект")]) : _vm._e(), _vm._v(" "), _c('socials')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1abbe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Footer.vue
// module id = 505
// module chunks = 1